export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "product__fitGuidance--sizeRecommender": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["Nuulyers like you said __size ", _interpolate(_list(0)), "__ fit.[See Details](#product-reviews-modal)"])},
        "product__fitGuidance--sizeRecommenderThreeOrMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A variety of sizes fit Nuulyers like you. [See details](#product-reviews-modal) for more fit guidance"])}
      }
    }
  })
}
